const riot = require('riot');

riot.tag2('modal-input-form', '<form class="modal relative elevation-default-mid bg-white rounded-4 {getModalClasses()}" ref="modal" onsubmit="{onSubmit}"><i class="icon-close absolute t8 r8 fs24 text-gray_30 cursor-pointer" onclick="{close}"></i> <div class="p32"> <div class="text-center ts-hm text-center text-navy mb24">{opts.title || \'確認\'}</div> <label class="block"> <div class="f fm mb8"> <div class="ts-hxs mr4">{opts.input_lable}</div> <div class="ts-hxxs text-pink_70" if="{opts.required}">必須</div> </div> <input class="input w-full" required="{opts.required}" ref="input" riot-value="{opts.value}"> </label> </div> <div data-is="module-section-footer" buttons="{opts.buttons}"></div> </form>', 'modal-input-form .modal,[data-is="modal-input-form"] .modal{max-width:80vw}', 'class="f fh s-full px16 bg-modal_overlay" spat-animation="fade"', function(opts) {
    this.on('mount', () => {
      requestAnimationFrame(() => {
        this.refs.input.focus();
      });
    });

    this.onSubmit = async (e) => {
      e.preventDefault();
      if (this.opts.submit) {
        try {
          await this.opts.submit(this.refs.input.value);
          this.value = this.refs.input.value;
          this.close();
        }
        catch (e) {
          console.error(e);
          spat.modal.alert(e.message);
        }
      }
    };

    this.getModalClasses = () => {
      var size = this.opts.size || 'medium';
      return {
        large: 'w760',
        medium: 'w440',
      }[size];
    };
});